export const formatRating = (rating?: number) =>
  typeof rating === "number" && `${Math.round(rating)}%`
